import { apiClient } from './config'
import type { Client } from '../types'

export const clientApi = {
  /**
   * Récupère les informations d'un client par son ID public
   */
  getClientByPublicId: async (publicId: string): Promise<Client> => {
    const response = await apiClient.get(`/client/${publicId}`)
    return response.data
  }
}
